'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { ArrowUndoIcon } from '@navikt/aksel-icons';
import { BodyShort } from '@navikt/ds-react';
import { setBreadcrumbs } from '@navikt/nav-dekoratoren-moduler';
import { store } from '@/app/_components/store/store';
import { LinkButton } from '@/components/link-button/LinkButton';
import Spinner from '@/components/spinner/Spinner';
import { areaPath } from '@/urls';
import ArbeidsforholdDetaljer from 'app/_components/arbeidsforhold/Arbeidsforhold';
export const Arbeidsforhold = () => {
  const $ = _c(19);
  const {
    tekst,
    arbeidsgiver
  } = store.useReducerState();
  const {
    SET_ARBEIDSGIVER_VIEW
  } = store.useActions();
  const {
    arbeidsforhold,
    arbeidsforholdLoading
  } = arbeidsgiver;
  let t0;
  if ($[0] !== tekst._prefix || $[1] !== tekst.breadcrumbs.arbeidsforhold || $[2] !== tekst.breadcrumbs.arbeidssted || $[3] !== tekst.landing.arbeidsgiver.heading) {
    t0 = () => {
      setBreadcrumbs([{
        title: tekst.landing.arbeidsgiver.heading,
        url: areaPath("arbeidsgiver", tekst._prefix),
        handleInApp: true
      }, {
        title: tekst.breadcrumbs.arbeidssted,
        url: areaPath("arbeidsgiver", tekst._prefix, "/arbeidssted"),
        handleInApp: true
      }, {
        title: tekst.breadcrumbs.arbeidsforhold,
        url: areaPath("arbeidsgiver", tekst._prefix, "/arbeidssted/arbeidsforhold"),
        handleInApp: true
      }]);
    };
    $[0] = tekst._prefix;
    $[1] = tekst.breadcrumbs.arbeidsforhold;
    $[2] = tekst.breadcrumbs.arbeidssted;
    $[3] = tekst.landing.arbeidsgiver.heading;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== tekst) {
    t1 = [tekst];
    $[5] = tekst;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== SET_ARBEIDSGIVER_VIEW) {
    t2 = () => SET_ARBEIDSGIVER_VIEW("arbeidssted");
    $[7] = SET_ARBEIDSGIVER_VIEW;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowUndoIcon aria-hidden={true} />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2) {
    t4 = <BodyShort spacing={true}><LinkButton onClick={t2}>{t3}Tilbake til arbeidssted</LinkButton></BodyShort>;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== arbeidsforhold || $[13] !== arbeidsforholdLoading || $[14] !== tekst.loading) {
    t5 = arbeidsforholdLoading ? <Spinner tekst={tekst.loading.hentArbeidsforholddetaljer} /> : arbeidsforhold ? <ArbeidsforholdDetaljer data={arbeidsforhold} /> : null;
    $[12] = arbeidsforhold;
    $[13] = arbeidsforholdLoading;
    $[14] = tekst.loading;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default Arbeidsforhold;